@if (showMovedTiersSettingsInfo && !forceLoadLatestValues) {
  <div class="message normal-font">
    To never show Moved Currency & Unique tiers in the future, you can disable it on the Settings tab, or by clicking <a [href]="null"  class="action-link" (click)="neverShowMovedCurrency($event)">here</a>.
  </div>
}
@if (!forcedFixedMode && playingSsf && !forceLoadLatestValues) {
  <div class="message normal-font">
    There were changes to Currency or Unique values and tiers since your last visit. Since your're using Fixed (SSF) economy tiering mode you are presumably not interested. Change your Tiering Mode to anything but 'Fixed (SSF)' to view the changes.
  </div>
}
@if (!playingSsf && noCurrencyAndUniqueChanges && !forceLoadLatestValues) {
  <div class="message normal-font">
    There were no changes to Currency or Uniques since your last visit. Click <a [href]="null"  class="action-link" (click)="showLatestChanges($event)">here</a> to review the latest changes.
  </div>
}
@if (displayMovedTiers && settings.showMovedTiers()) {
  <div class="search-advanced-items">
    <div class="search-advanced-pane full-width">
      <div class="filter-group">
        <div class="filter-group-header">
          <div class="filter">
            <span class="filter-body">
              <span class="filter-title info">
                @if (forceLoadLatestValues) {
                  Most recent changes to Currency & Unique tiers
                } @else {
                  Moved Currency & Unique tiers since last visit
                }
                <div class="close-info-btn" (click)="displayMovedTiers = false; showMovedTiersSettingsInfo = !forceLoadLatestValues; forceLoadLatestValues = false">✕</div>
              </span>
            </span>
          </div>
        </div>
        <div class="filter-group-body moved-tiers">
          <div class="moved-tier moved-tier-info">
            @if (!forceLoadLatestValues) {
              <div>We've updated the values and tiers of Currency and/or Uniques{{ economyService.lastUpdateType === 'launch' ? ' since your last visit.' : '.' }}</div>
            }
            @if (economyService.lastUpdateSyncing) {
              <div>Syncing changes...</div>
            } @else if (economyService.lastUpdateHadSyncError) {
              <div><strong>An error occurred while syncing changes</strong>. Use the controls below to sync manually.</div>
            } @else if (economyService.lastUpdateWasSynced) {
              <div>Changes successfully synced to your account. Refresh the filter in-game to apply.</div>
            }
            @if (economyService.inflationData()) {
              <div>Previous values: <span class="extra-info">{{ economyService.inflationData()?.previousDate }}</span></div>
              <div>Latest values: <span class="normal-item-color">{{ economyService.inflationData()?.latestDate }}</span></div>
              <div>
                Divine price change: <span class="normal-item-color" app-value baseType="Divine Orb" [showPreviousValue]="true" [forceRefresh]="economyService.inflationData()"></span>
                (<span [style.color]="economyService.inflationData()?.color">{{ economyService.inflationData()?.formatted }}</span>)
              </div>
            }
            <div>Selected Tiering Mode: <span class="extra-info">{{ filter.economy }}, {{ tieringModeMap[filter.tieringMode] }}</span></div>
            <div>
              (<a class="cursor-pointer" (click)="$event.preventDefault(); setGroupingMode(settings.movedTiersGroupingMode() === 'movement' ? 'tier' : 'movement')">{{ settings.movedTiersGroupingMode() === 'movement' ? 'group by tier' : 'group by movement' }}</a>)
            </div>
          </div>
          @if (settings.movedTiersGroupingMode() === 'movement') {
            <app-moved-tier-section
              sectionTitle="Moved up two tiers"
              icon="↑↑"
              cssClass="moved-tier-two-up"
              [isHidden]="false"
              [currencyItems]="currencyByMovement().increasedTwoTiers"
              [uniqueItems]="uniquesByMovement().increasedTwoTiers"
              [alwaysGroupByBaseType]="alwaysGroupByBaseType"
              [currency]="currency"
              [groupingMode]="settings.movedTiersGroupingMode()">
            </app-moved-tier-section>
            <app-moved-tier-section
              sectionTitle="Moved up one tier"
              icon="↑"
              cssClass="moved-tier-one-up"
              [isHidden]="false"
              [currencyItems]="currencyByMovement().increasedOneTier"
              [uniqueItems]="uniquesByMovement().increasedOneTier"
              [alwaysGroupByBaseType]="alwaysGroupByBaseType"
              [currency]="currency"
              [groupingMode]="settings.movedTiersGroupingMode()">
            </app-moved-tier-section>
            <app-moved-tier-section
              sectionTitle="Moved down one tier"
              icon="↓"
              cssClass="moved-tier-one-down"
              [isHidden]="false"
              [currencyItems]="currencyByMovement().decreasedOneTier"
              [uniqueItems]="uniquesByMovement().decreasedOneTier"
              [alwaysGroupByBaseType]="alwaysGroupByBaseType"
              [currency]="currency"
              [groupingMode]="settings.movedTiersGroupingMode()">
            </app-moved-tier-section>
            <app-moved-tier-section
              sectionTitle="Moved down two tiers"
              icon="↓↓"
              cssClass="moved-tier-two-down"
              [isHidden]="false"
              [currencyItems]="currencyByMovement().decreasedTwoTiers"
              [uniqueItems]="uniquesByMovement().decreasedTwoTiers"
              [alwaysGroupByBaseType]="alwaysGroupByBaseType"
              [currency]="currency"
              [groupingMode]="settings.movedTiersGroupingMode()">
            </app-moved-tier-section>
          } @else {
            @for (entry of currencyByTier(); track entry[0]) {
              @let tier = entry[0];
              @let tierItems = entry[1];
              @let firstItem = tierItems[0];
              <app-moved-tier-section
                [sectionTitle]="tier + '-Tier Currency'"
                icon=""
                [cssClass]="getGradientClassForTier(tier, firstItem.tierColor || 'grey', false)"
                [isHidden]="firstItem.isHidden"
                [currencyItems]="tierItems"
                [uniqueItems]="[]"
                [alwaysGroupByBaseType]="alwaysGroupByBaseType"
                [currency]="currency"
                [groupingMode]="settings.movedTiersGroupingMode()">
              </app-moved-tier-section>
            }
            @for (entry of uniquesByTier(); track entry[0]) {
              @let tier = entry[0];
              @let tierItems = entry[1];
              @let firstItem = tierItems[0];
              <app-moved-tier-section
                [sectionTitle]="tier + '-Tier Uniques'"
                icon=""
                [cssClass]="getGradientClassForTier(tier, firstItem.tierColor || 'grey', true)"
                [isHidden]="firstItem.isHidden"
                [currencyItems]="[]"
                [uniqueItems]="tierItems"
                [alwaysGroupByBaseType]="alwaysGroupByBaseType"
                [currency]="currency"
                [groupingMode]="settings.movedTiersGroupingMode()">
              </app-moved-tier-section>
            }
          }
        </div>
      </div>
    </div>
  </div>

  @if ((!economyService.lastUpdateSyncing && !economyService.lastUpdateWasSynced) || economyService.lastUpdateHadSyncError) {
    <app-controls style="display: block; margin-bottom: 12px"
      [showLeft]="false"
      [showCenter]="true"
      [showRight]="false"
      [isBeta]="isBeta"
      [isLegacy]="isLegacy"
      [tab]="'changelog'"
      [initialVisit]="initialVisit"
    >
    </app-controls>
  }
}

<div class="search-advanced-pane full-width changelog-list">
  <div class="filter-group">

    @for (entry of changelogEntries; track entry.title; let first = $first) {
      <div class="row row-total row-justify-content-left changelog-entry">
        <div class="filter-group-header">
          <div class="filter">
            <span class="filter-body">
              <span class="filter-title">
                {{ entry.title }}
                <span *ngIf="entry.version || entry.date" class="title-version">{{ entry.version }} {{ entry.version ? '-' : '' }} {{ entry.date }}</span>
              </span>
            </span>
          </div>
        </div>
        <div class="filter-group-body changelog-body normal-font">
          <div [innerHTML]="entry.content" class="changelog-body-changes"></div>
          <div class="changelog-body-images">
            @for (image of entry.images; track image.src; let imageIndex = $index) {
              @if (image.href) {
                <a [href]="image.href" target="_blank" rel="noopener" class="no-icon changelog-image-link">
                  <img class="changelog-image" [src]="assetBaseUrl + image.src">
                </a>
              } @else {
                <img
                  class="changelog-image"
                  [src]="assetBaseUrl + image.src"
                  (click)="openLightbox(entry.images, imageIndex)">
              }
            }
          </div>
        </div>
      </div>

      @if (first && !(displayMovedTiers && settings.showMovedTiers())) {
        <app-controls style="display: block; margin-bottom: 12px"
          [showLeft]="false"
          [showCenter]="true"
          [showRight]="false"
          [isBeta]="isBeta"
          [isLegacy]="isLegacy"
          [tab]="'changelog'"
          [initialVisit]="initialVisit">
        </app-controls>
      }
    }

    @if (!archiveLoaded) {
      <div class="changelog-load-archive normal-font">
        @if (loadingArchive) {
          Loading archive...
        } @else {
          <a [href]="null" class="action-link" (click)="loadArchive($event)">Load complete archive</a>
        }
      </div>
    }

  </div>
</div>

@if (lightboxOpen) {
  <div class="modal-overlay active" (click)="onLightboxOverlayClick($event)">
    <div class="modal-content">
      <img [src]="lightboxImageSrc" alt="Changelog image" (click)="showNextLightboxImage()">
    </div>
  </div>
}
